module.exports = __webpack_public_path__ + "img/icon-check.325ebda8.svg";